import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

/** Errors/important messages: role="alert" so screen readers announce them immediately. */
export function Alert({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      role="alert"
      className={cn(
        'rounded-xl border border-danger-border bg-danger-bg text-danger-text px-4 py-3 text-sm',
        className,
      )}
    >
      {children}
    </div>
  );
}
